export const INACTIVE_CURRENCY_ERROR_CODE = 'INACTIVE_CURRENCY'
